var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 141,
    viewBox: "0 0 208 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 208,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.895,
    y: 21,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.895,
    y: 90,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.895,
    y: 55,
    width: 158.239,
    height: 30,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1962 32.047H40.2322V41H38.9022V33.622C38.6689 33.7573 38.4309 33.8623 38.1882 33.937C37.9456 34.007 37.7029 34.0467 37.4602 34.056V32.768C37.7636 32.7307 38.0576 32.656 38.3422 32.544C38.6316 32.4273 38.9162 32.2617 39.1962 32.047Z",
    fill: "#004552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.089 110.182C38.6317 110.182 38.1907 110.119 37.766 109.993C37.3413 109.862 36.9587 109.676 36.618 109.433C36.282 109.186 36.016 108.88 35.82 108.516C35.624 108.147 35.526 107.723 35.526 107.242H36.912C36.926 107.606 37.0287 107.916 37.22 108.173C37.4113 108.43 37.668 108.626 37.99 108.761C38.312 108.892 38.6783 108.957 39.089 108.957C39.705 108.957 40.1833 108.81 40.524 108.516C40.8693 108.222 41.042 107.853 41.042 107.41C41.042 107.125 40.9697 106.876 40.825 106.661C40.685 106.446 40.4633 106.281 40.16 106.164C39.8613 106.043 39.4717 105.982 38.991 105.982H37.906V104.932H38.732C39.348 104.932 39.8333 104.806 40.188 104.554C40.5427 104.297 40.72 103.95 40.72 103.511C40.72 103.119 40.573 102.79 40.279 102.524C39.985 102.258 39.558 102.125 38.998 102.125C38.5547 102.125 38.1603 102.216 37.815 102.398C37.4697 102.575 37.241 102.895 37.129 103.357H35.75C35.82 102.778 36.002 102.309 36.296 101.95C36.59 101.591 36.9657 101.329 37.423 101.166C37.8803 101.003 38.3913 100.921 38.956 100.921C39.5673 100.921 40.1133 101.026 40.594 101.236C41.0793 101.441 41.4597 101.728 41.735 102.097C42.0103 102.466 42.148 102.89 42.148 103.371C42.148 103.833 42.0173 104.232 41.756 104.568C41.4993 104.899 41.1237 105.154 40.629 105.331C41.1797 105.499 41.6277 105.767 41.973 106.136C42.3183 106.5 42.491 106.962 42.491 107.522C42.491 108.04 42.351 108.5 42.071 108.901C41.791 109.302 41.3967 109.617 40.888 109.846C40.3793 110.07 39.7797 110.182 39.089 110.182Z",
    fill: "#004552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.708 75V73.593C35.708 73.0843 35.7873 72.6573 35.946 72.312C36.1047 71.962 36.3357 71.6703 36.639 71.437C36.9423 71.2037 37.311 71.003 37.745 70.835L39.537 70.135C39.9663 69.9623 40.286 69.743 40.496 69.477C40.706 69.211 40.811 68.882 40.811 68.49C40.811 68.084 40.6687 67.748 40.384 67.482C40.0993 67.216 39.6957 67.083 39.173 67.083C38.6643 67.083 38.242 67.1997 37.906 67.433C37.5747 67.6617 37.3857 68.0047 37.339 68.462H35.862C35.8853 67.9067 36.0393 67.44 36.324 67.062C36.6087 66.684 36.9937 66.3993 37.479 66.208C37.9643 66.0167 38.522 65.921 39.152 65.921C39.74 65.921 40.2673 66.033 40.734 66.257C41.2007 66.481 41.5693 66.7913 41.84 67.188C42.1153 67.5847 42.253 68.042 42.253 68.56C42.253 69.022 42.169 69.4257 42.001 69.771C41.833 70.1117 41.5857 70.408 41.259 70.66C40.9323 70.912 40.5357 71.1313 40.069 71.318L38.249 72.039C37.8383 72.1977 37.5327 72.3843 37.332 72.599C37.136 72.809 37.038 73.0843 37.038 73.425V73.775H42.183V75H35.708Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots1);
export default __webpack_public_path__ + "static/media/slots-1.1293fb8e8f9b9fb7b4e025b19470bc63.svg";
export { ForwardRef as ReactComponent };